import { botFlowSelector } from './botFlowSelector'
import { RootState } from '../../../reducers'

export function loadedBotVersionSelector(state: RootState): string | undefined {
  return botFlowSelector(state)?.version
}
